import React, {createContext, useState} from 'react';

export const shopContext = createContext();
const {Provider} = shopContext;

const ShopContext = props => {
  const [cartProducts, setCartProducts] = useState([]);
  const [defaultAddress, setDefaultAddress] = useState(null);
  const [defaultCard, setDefaultCard] = useState(null);
  const [canUserCheckout, setCanUserCheckout] = useState(false);
  const [addOrEditAddress, setAddOrEditAddress] = useState(false);

  // useEffect(() => {
  //   (async () => {
  //     let cartitems = await getData(KEYS.cartItems)
  //     if (cartitems) {
  //       setCartProducts(JSON.parse(cartitems))
  //     }
  //   })()
  // }, [])

  // useEffect(() => {
  //   if (cartProducts.length > 0) {
  //     storeData(KEYS.cartItems, JSON.stringify(cartProducts))
  //   }
  // }, [cartProducts, defaultAddress, defaultCard])

  return (
    <Provider
      value={{
        cartProducts,
        defaultAddress,
        defaultCard,
        setCartProducts,
        setDefaultAddress,
        setDefaultCard,
        canUserCheckout,
        setCanUserCheckout,
        addOrEditAddress,
        setAddOrEditAddress,
      }}>
      {props.children}
    </Provider>
  );
};

export default ShopContext;
